<template>
  <div>
    <div id="lineChart" class="chart-box user-chart-box"></div>
  </div>
</template>
<script>
import * as Echarts5 from 'echarts5.3.0';

export default {
  props: {
    seriesList: {
      type: Array,
      default: () => [0],
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      xLineArray: new Array(24)
        .fill(0)
        .map((_item, index) => `${index < 10 ? `0${index}` : `${index}`}:00`),
      lineChart: null,
    };
  },
  watch: {
    isRefresh() {
      if (this.isRefresh) {
        this.handleChartRender();
      }
    },
  },
  mounted() {
    this.lineChart = Echarts5.init(document.getElementById('lineChart'));
    if (!this.seriesList.length) {
      const option = this.renderLineChart(this.xLineArray, [0], [0]);
      this.lineChart.setOption(option);
    } else {
      this.handleChartRender();
    }

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    // 绘制图表
    handleChartRender() {
      const option = this.renderLineChart(this.xLineArray, this.seriesList);
      this.lineChart?.clear();
      this.lineChart?.setOption(option);
    },
    // 线堆叠
    renderLineChart(xLineArray, data) {
      return {
        // 平滑
        smooth: true,
        legend: {
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          right: 'auto',
          top: '20px',
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          axisPointer: {
            type: 'line',
            axis: 'x',
            label: {
              show: true,
              color: 'rgb(255, 151)',
              backgroundColor: 'rgba(255, 255, 255, .8)',
              shadowBlur: 0,
              margin: 0,
            },
            lineStyle: {
              type: 'dashed',
              color: '#b6b5b7',
            },
          },
          // textStyle: {
          color: '#333',
          align: 'left',
          fontSize: 14,
          // },
          formatter(params) {
            let resData = '';
            params.forEach((it) => {
              resData += `
                <div style="display: flex;min-width: 120px;justify-content: space-between">
                  <div>
                    <p
                      style="
                      display: inline-block;
                      border-radius: 10px;
                      height: 10px;
                      width: 10px;
                      background-color: ${it.color};"
                    ></p>
                    ${it.seriesName}
                  </div>
                  <p><strong>${it.value}</strong></p>
                </div>`;
            });

            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;"
              >
                <div>${params[0].axisValueLabel}</div>
                ${resData}
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 5;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        // toolbox: {
        //   feature: {
        //     // dataZoom: {
        //     //   yAxisIndex: 'none',
        //     //   xAxisIndex: 'none',
        //     // },
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        grid: {
          height: '200',
          left: '0%',
          right: '2%',
          bottom: '4%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xLineArray,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: '#b6b5b7', // 坐标值得具体的颜色
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          // 设置轴线的属性
          axisLine: {
            show: true,
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: '#b6b5b7', // 坐标值得具体的颜色

            // textStyle: {
            //   color: '#b6b5b7', // 坐标值得具体的颜色
            // },
          },
        },
        series: data,
      };
    },
    handleResize() {
      this.lineChart.resize();
    },
  },
};
</script>
<style lang="scss" scoped>
.user-chart-box {
  height: 294px;
}
</style>
